var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WistiaMovie',{attrs:{"asset":"jmfdsuq0sg","autoplay":_vm.autoplay}},[_c('b-btn',[_vm._v("Watch movie "),_c('i',{staticClass:"far fa-play-circle"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cb5e63c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/homepage/shared/HowItWorksButton.vue
// module id = zDIk
// module chunks = 1